import { gql } from 'apollo-boost';

export const portfolioSelect = gql`
  query {
    allPortfolios(filters: {enabled: true}) {
      edges {
        node {
          portfolioId
          name
          year
          mainPortfolioId
          isPartnerQueue
          isImpactSnapshot
        }
      }
    }
  }
`;
